/** External Imports */
import { useNavigate } from "react-router-dom";

/** Internal Imports */
import CSS from "./ConfirmNotification.module.css";
import CardContainer from "@/Component/Elements/CardContainer/CardContainer";
import useMainREST from "@/CustomerPage/MainHome/components/WrokRequiredNotification/hooks/useMainREST.hook";
import useWrokRequiredNotificationDataSetter from "@/CustomerPage/MainHome/components/WrokRequiredNotification/hooks/useWrokRequiredNotificationDataSetter.hook";
import { PRODUCT_LIST_FILTER_CODE_OBJ } from "@/CustomerPage/ProductManufacturing/static/ts/const";
import { RESERVATION_LIST_FILTER_CODE } from "@/CustomerPage/Reservation/static/ts/const";
import { PHOTO_LIST_FILTER_CODE } from "@/CustomerPage/PhotoList/static/ts/const";
import { getQueryParamsUrl } from "@/Common/ts/commonTools";
import { backPointUrlManagerClass } from "@/Common/ts/appTools";

const backPointUrlManager = new backPointUrlManagerClass();





const ConfirmNotification = () => {
    const navigate = useNavigate();

    const {
        mainData,
    } = useMainREST();

    const {
        selectPhotoCount,
        confPhotoCount,
        selectThemeCount,
        eventReviewCount,
    } = useWrokRequiredNotificationDataSetter({ mainData });

    const l_back_point_url = backPointUrlManager.encoded({ url: "/" });

    const moveNeedToRequestTagHandler = () => {
        const m_productList_url = getQueryParamsUrl({
            main_url: "/productList",
            queryParams: {
                tab1: PRODUCT_LIST_FILTER_CODE_OBJ.need_to_request,
                back_point: l_back_point_url,
            }
        });

        navigate(m_productList_url);
    };

    const moveNeedToConfirmTagHandler = () => {
        const m_productList_url = getQueryParamsUrl({
            main_url: "/productList",
            queryParams: {
                tab1: PRODUCT_LIST_FILTER_CODE_OBJ.need_to_confirm,
                back_point: l_back_point_url,
            }
        });

        navigate(m_productList_url);
    };

    const moveThemeSelectTagHandler = () => {
        const m_reservationHome_url = getQueryParamsUrl({
            main_url: "/reservationHome",
            queryParams: {
                tab1: RESERVATION_LIST_FILTER_CODE.reservat,
                back_point: l_back_point_url,
            }
        });

        navigate(m_reservationHome_url);
    };

    const moveReviewEventTagHandler = () => {
        const m_photoList_url = getQueryParamsUrl({
            main_url: "/photoList",
            queryParams: {
                tab1: `${PHOTO_LIST_FILTER_CODE.shoot}`,
                back_point: l_back_point_url,
            }
        });

        navigate(m_photoList_url);
    };

    const requestItemList = [
        {
            text: "테마 선택 요청",
            itemNum: selectThemeCount,
            onClick: moveThemeSelectTagHandler,
        },
        {
            text: "사진 선택 요청",
            itemNum: selectPhotoCount,
            onClick: moveNeedToRequestTagHandler,
        },
        {
            text: "사진 승인 요청",
            itemNum: confPhotoCount,
            onClick: moveNeedToConfirmTagHandler,
        },
        {
            text: "후기 이벤트 신청",
            itemNum: eventReviewCount,
            onClick: moveReviewEventTagHandler,
        },
    ];

    return (
        <CardContainer class_name_list={[CSS.ConfirmNotification]}>
            <h3 className={CSS.Title}>
                고객님, 확인해주세요!
            </h3>

            <div className={CSS.ItemGrid}>
                {requestItemList.map((iItem) => (
                    <CardContainer
                        key={iItem.text}
                        class_name_list={[CSS.RequestCard]}
                        onClick={iItem.onClick}
                    >
                        <div className={CSS.RequestCardBody}>
                            <span className={CSS.RequestCardTitle}>
                                {iItem.text}
                            </span>
                            <strong
                                className={[
                                    CSS.RequestCardCount,
                                    iItem.itemNum > 0
                                        ? CSS.RequestCardCountActive
                                        : CSS.RequestCardCountMuted
                                ].join(" ")}
                            >
                                {iItem.itemNum}건
                            </strong>
                        </div>
                    </CardContainer>
                ))}
            </div>
        </CardContainer>
    );
};

export default ConfirmNotification;
